import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../../controller/api';
import Cookies from 'js-cookie';
import LoaderModal from '../../components/LoaderModal';

const ProtectedRoute = ({ children, requireSubscription }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [hasTrainingAccess, setHasTrainingAccess] = useState(true);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = Cookies.get('token'); // Retrieve the token from cookies
console.log(token)
        if (!token) {
          setIsAuthenticated(false);
          setLoading(false);
          return;
        }

        const res = await axios.post(
          `${API}/auth/refresh-user-web`,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`, // Pass token in Authorization header
            },
          }
        );

        const user = res.data.user;
        setIsAuthenticated(true);
        setHasActiveSubscription(user.subscription && user.subscription.isActive);
        setHasTrainingAccess(true);
        console.log(hasTrainingAccess)
        console.log(hasActiveSubscription)
      } catch (error) {
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  if (loading) return <LoaderModal open={true}/>;

  if (!isAuthenticated) return <Navigate to="/login" />;

  if (requireSubscription) {
    if (hasActiveSubscription) {
      // Allow access if the subscription is active
      return children || <Outlet />;
    } else if (hasTrainingAccess && location.pathname === '/training') {
      // Allow access to /training if the user has training access
      return children || <Outlet />;
    } else {
      // Redirect to /training if the user has training access but an inactive subscription
      return <Navigate to="/training" />;
    }
  }

  return children || <Outlet />;
};

export default ProtectedRoute;
